import { render, staticRenderFns } from "./ArticlesLeft.vue?vue&type=template&id=40f9737d&scoped=true&"
import script from "./ArticlesLeft.vue?vue&type=script&lang=js&"
export * from "./ArticlesLeft.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesLeft.vue?vue&type=style&index=0&id=40f9737d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9737d",
  null
  
)

export default component.exports